import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.invite.label",
    defaultMessage: "Invite new user",
    description: "Invite new user button label",
  },
});
